import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import {
  ORGANIZATION_USER,
  APPLICATION_USER,
  ORGANIZATION,
} from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
/**
 * list the Organization Users.
 * @returns {Promise} - A promise that resolves with the list of OrganizationUsers or rejects with an error.
 * @param props
 */
export const listOrganizationUser = async ({
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
  orgId,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset == 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };
  const { accessToken } = getTokensFromStorage();
  if (!orgId) {
    return {
      organizationUsers: [],
      TotalCount: -1,
    };
  }
  const response = await apiServiceWrapper({
    url: `${ORGANIZATION_USER.replace('{orgId}', orgId)}`,
    method: 'POST',
    body: data,
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    organizationUsers: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * create the Organization User.
 * @returns {Promise} - A promise that resolves with the creation of OrganizationDetail UserDetail or rejects with an error.
 * @param data
 */
export const createOrganizationUser = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ORGANIZATION}/Users`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * delete the Organization user.
 * @returns {Promise} - A promise that resolves with the delete of OrganizationDetail UserDetail or rejects with an error.
 * @param data
 */
export const deleteOrganizationUser = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
  orgId,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${ORGANIZATION_USER.replace('{orgId}', orgId)}/${data?.UserId}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * delete the user from the system.
 * @returns {Promise} - A promise that resolves with the delete of user or rejects with an error.
 * @param data
 */
export const deleteUser = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${APPLICATION_USER}/${data?.UserId}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * list the Users which are Not In Organization.
 * @returns {Promise} - A promise that resolves with the list of OrganizationUsers or rejects with an error.
 * @param props
 */
export const listUserNotInOrganization = async ({
  moduleName,
  isServiceWorker,
  listController,
  orgId,
}) => {
  const { accessToken } = getTokensFromStorage();
  if (!orgId) {
    return {
      organizationUsers: [],
      TotalCount: -1,
    };
  }
  const response = await apiServiceWrapper({
    url: `${ORGANIZATION}/NotInUserOrg?id=${orgId}`,
    method: 'Get',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    organizationUsers: response.Payload?.filter((item) => !item.IsVirtual),
    TotalCount: response?.TotalRecordCount,
  };
};
